<template>
  <div class="page-wrapper">
    <div class="page-content--bge5">
      <div class="container">
        <div class="login-wrap">
          <div class="login-content">
            <div class="login-logo">
              <img alt="" src="/images/logo.png" class="sidebar-logo">
            </div>
            <div class="login-form" v-if="!isEmailSend">
              <div class="text-center" style="color: red;" v-if="error">{{ error }}</div>
              <form @submit.prevent="onSubmit">
                <div :class="{invalid: $v.form.email.$error}" class="form-group">
                  <label for="email">
                    {{ text('email') }}
                  </label>
                  <input
                    @blur="onEmailBlur"
                    class="au-input au-input--full"
                    id="email"
                    :placeholder="text('email_placeholder')"
                    type="email"
                    v-model="form.email">
                </div>
                <button
                  :disabled="isLoaded"
                  class="au-btn au-btn--block au-btn--green m-b-20"
                  type="submit">
                  <span
                    class="spinner-border spinner-grow-sm"
                    style="margin-bottom: 4px; margin-right: 4px;"
                    v-if="isLoaded">
                  </span>{{ text('submit') }}
                </button>
              </form>
              <div class="register-link">
                <p>
                  <router-link :to="{name: 'SignIn'}" tag="a">
                    {{ text('return_to_sign_in') }}
                  </router-link>
                </p>
              </div>
            </div>

            <div class="card border border-success" v-if="isEmailSend">
              <div class="card-header">
                <strong class="card-title">
                  {{ text('password_reset_sent') }}
                </strong>
              </div>
              <div class="card-body">
                <p class="card-text">
                  {{ text('password_reset_text') }}
                </p>
                <div class="register-link">
                  <p>
                    <router-link :to="{name: 'SignIn'}" tag="a">
                      {{ text('return_to_sign_in') }}
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      form: {
        email: '',
      },
      error: '',
      isLoaded: false,
      isEmailSend: false,
    };
  },
  computed: {
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
  methods: {
    onEmailBlur() {
      this.$v.form.email.$touch();
      this.error = '';
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;

      this.isLoaded = true;
      this.$store.dispatch('passwordReset', this.form.email)
        .then(() => {
          this.isEmailSend = true;
        })
        .catch((errorMsg) => {
          this.error = errorMsg;
        })
        .finally(() => {
          this.isLoaded = false;
        });
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return code;
    },
  },
};
</script>

<style scoped>
  .invalid label {
    color: red;
  }

  .invalid input {
    border: 1px solid red;
    background-color: #ffc9aa;
  }
</style>
